import { defineStore } from "pinia";
import "bezier-easing";
import { metricsClick } from "../util/genericAnalytics.mjs";
import { daysUntilNow } from "../util/dates.mjs";
import "js-cookie";
import useProductAppPropsStore from "./productAppPropsStore.mjs";
import useProductBuyBoxStore from "./productBuyBoxStore.mjs";
import useProductDataStore from "./productDataStore.mjs";
import useProductFulfillmentStore from "./productFulfillmentStore.mjs";
import useProductMessagesStore from "./productMessagesStore.mjs";
import useProductPageStore from "./productPageStore.mjs";
const PREFIX = "rei:pdp_";
const SITE_ID = "rei";
const useProductAnalyticsStore = defineStore("productAnalyticsStore", {
  state: () => ({
    analytics: {},
    analyticsConfig: {
      prefix: PREFIX,
      siteId: SITE_ID
    }
  }),
  getters: {
    computedProductString() {
      var _a, _b, _c;
      const { product } = useProductDataStore();
      const { computedIsMemberOnly, computedSelectedSku } = useProductPageStore();
      const isMemberFirst = !!useProductMessagesStore().messages.promo.memberFirst;
      const { quantity } = useProductBuyBoxStore();
      const { shipping, computedSelectedShippingMethod } = useProductFulfillmentStore();
      const unitPrice = (computedSelectedSku == null ? void 0 : computedSelectedSku.price) ? (_a = computedSelectedSku.price.price) == null ? void 0 : _a.value : "";
      const storeType = product.outlet ? "outlet" : "rei";
      const fulfillmentType = (_b = shipping.selectedStore) == null ? void 0 : _b.storeFulfillmentType;
      const shipTimestamp = shipping.shippingAvailability.estimatedArrivalTimestamp;
      const shipEad = shipTimestamp ? daysUntilNow(/* @__PURE__ */ new Date(), new Date(shipTimestamp)) : null;
      const pickTimestamp = (_c = shipping.selectedStore) == null ? void 0 : _c.estimatedArrivalTimestamp;
      const pickupEad = pickTimestamp ? daysUntilNow(/* @__PURE__ */ new Date(), new Date(pickTimestamp)) : null;
      const selectedEad = computedSelectedShippingMethod === "SHIP" ? shipEad : pickupEad;
      let products = `;${product.styleId};${quantity};${unitPrice};;eVar4=${computedSelectedShippingMethod}|eVar17=${storeType}`;
      if (computedSelectedSku == null ? void 0 : computedSelectedSku.skuId) products += `|eVar84=${computedSelectedSku.skuId}`;
      if (selectedEad !== null) products += `|eVar83=${selectedEad}`;
      if (pickupEad !== null) products += `|eVar96=${pickupEad}`;
      if (shipEad !== null) products += `|eVar152=${shipEad}`;
      if (computedIsMemberOnly) products += "|eVar79=member only";
      if (isMemberFirst) products += "|eVar79=member first";
      if (fulfillmentType) products += `|eVar153=${fulfillmentType}`;
      if (shipping.shippingAddress.postalCode) products += `|eVar155=${shipping.shippingAddress.postalCode}`;
      return products;
    }
  },
  actions: {
    async handleMetricsClick(config) {
      var _a, _b;
      const {
        testOverride,
        event,
        link,
        linkName,
        clickData
      } = config;
      const click = testOverride || metricsClick;
      const navigate = await click(
        {
          linkName: `${this.analyticsConfig.prefix}${linkName}`,
          products: this.computedProductString,
          ...clickData
        },
        {
          logOverride: (_b = (_a = useProductAppPropsStore().appPropsMap) == null ? void 0 : _a.devToggles) == null ? void 0 : _b.analyticsToConsole,
          event,
          link
        }
      );
      if (navigate) navigate();
    },
    handleMetricsView() {
    }
  }
});
export {
  useProductAnalyticsStore as default
};
//# sourceMappingURL=productAnalyticsStore.mjs.map
